import { useCallback, useEffect, useState } from "react";
import { Post } from "../../data-types/data-types";
import { findAll } from "../../services/blog";
import PostCard from "../Widgets/PostCard"

const Side = () => {
	const [posts, setPosts] = useState<any>([])
	const [isLoading, setIsLoading] = useState(true);

	const getPosts = useCallback(async () => {
		setIsLoading(true);
		const res = await findAll()
		if (res[0]) {
			setPosts(res);
			setIsLoading(false);
		} else {
			setTimeout(() => {
				getPosts();
			}, 2000);
		}
	}, [],)

	useEffect(() => {
		getPosts()
	}, [getPosts])
	return (
		<div className="w-full pb-10 md:w-[30rem] md:sticky md:top-28">
			{!isLoading &&
				<>
					<h3 className='font-serif text-slate-700 mb-2 font-bold dark:text-white'>
						Recent Posts
					</h3>
					{posts.map((each: Post, i: number) => (
						<PostCard data={each} key={i} className="my-3" />
					))}
				</>
			}
		</div>
	)
}

export default Side